import { extendTheme, theme as chakraTheme } from '@chakra-ui/react';

import { baseColorScheme } from './base-color-scheme';
import { baseTheme } from './base-theme';

const theme = extendTheme(baseTheme, baseColorScheme, chakraTheme);

export default theme;
